export default __webpack_public_path__ + "static/ui-tasks-add-assignee-ff6c6587c1c4098ab29d3772cb83abb4.png";